<template>
  <!-- 在homeTop添加消息组件,使用轮询的方式  -->
  <common-home-top>
    <template #left>
      <!-- 通知公告 -->
      <div class="system-message">
        <board-simple-overflow :data-list="messageList" :speed=".05">
          <template v-slot="{data}">
            <div class="message-item" @click="router.push(`/sys/message/view?id=${data.id}`)" :style="{'color': `${messageTextColor(data.messageLevel)}`}">{{data.messageTitle}}</div>
          </template>
        </board-simple-overflow>
      </div>
    </template>
    <template #right>
      <!-- 接收到的消息提醒,使用消息组件 -->
      <common-system-notice-component :notice-count="messageNotRead" :query-notice-list="queryNoticeList" :read-notice="readNotice"/>
    </template>
  </common-home-top>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import CommonHomeTop from "@/views/h5/common/home/components/top/CommonHomeTop.vue";
import BoardSimpleOverflow from "@/components/h5/board/BoardSimpleOverflow.vue";
import YqIcon from "@/components/YqIcon.vue";
import util from "@/util/util";
import commonApi from "@/api/commonApi";
import TableButton from "@/components/h5/button/TableButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import CommonSystemNoticeComponent from "@/views/h5/common/home/components/top/CommonSystemNoticeComponent.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    TableButton, YqIcon, CommonHomeTop, BoardSimpleOverflow, FormItems, FormItem, CommonSystemNoticeComponent
  },
  data() {
    return {
      userInfo: {},
      messageList: [],

      messageNotRead: 0,
      messageInterval: null,

    };
  },
  created() {
    util.getUserInfo().then(user => {
      this.userInfo = user;
      this.messageInterval = setInterval(() => {
        this.queryMessageCount();
        this.queryProclamation();
      }, 10000)
    })
  },
  unmounted() {
    // 离开页面时清空轮询
    if (this.messageInterval) {
      clearInterval(this.messageInterval)
    }
  },
  methods: {
    // 查询消息数量,未读消息
    queryMessageCount() {
      commonApi.queryMySystemNotice({pageNumber: 1, pageSize: 1, searchType: 0}).then(res => {
        this.messageNotRead = res.totalCount;
      })
    },
    // 通知消息列表
    queryProclamation() {
      commonApi.queryMySystemProclamation({pageNumber: 1, pageSize: 10, category: "PROCLAMATION"}).then(res => {
        this.messageList = res.records;
      })
    },
    // 搜索消息列表
    queryNoticeList(searchInfo) {
      return new Promise(resolve => {
        commonApi.queryMySystemNotice(searchInfo).then(res => {
          resolve(res);
        })
      });
    },
    // 公告的字体颜色，按照等级区分
    messageTextColor(level) {
      switch ( level) {
        case 1:
          return "var(--el-color-primary)";
        case 2:
          return "var(--el-color-warning)";
        case 3:
          return "var(--el-color-danger)";
        default:
          return "var(--yq-font-color-base)";
      }
    },
    // 读取消息，不需要回调
    readNotice(deviceType, ids) {
      this.messageNotRead -= ids.length;
      commonApi.readNotice(deviceType, ids);
    }
  }
};
</script>

<style lang="scss" scoped>
.system-message{
  width: 300px;
  height: 20px;
  margin-right: 20px;
  .message-item{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 20px;
    cursor: pointer;
    text-align: right;
  }
}

</style>